export default "__VITE_ASSET__DHJycJoH__"